exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-page div p {\n  text-align: left;\n}", ""]);

// exports
exports.locals = {
	"primary": "#aa4121",
	"secondary": "#ccc",
	"gray": "#636363"
};